// extracted by mini-css-extract-plugin
export default {"checkbox":"DismissableModal__checkbox-QHhr1"};